import {
  GET_RESTAURANT,
  GET_CATALOGS,
  GET_CATEGORIES,
  GET_MENUS,
} from "../types";
import { toast } from "react-toastify";
import firebase from "../../config/firebase";

export const getAllRestaurantList = () => async (dispatch) => {
  try {
    dispatch(fetchLoader(true));
    await firebase
      .firestore()
      .collection("users")
      .where("type", "==", "restaurant")
      .where("subScriptionStatus", "==", "subscribe")
      .orderBy("createdAt", "asc")
      .onSnapshot((query) => {
        let allRestaurants = [];
        for (let doc of query.docs) {
          if (doc.exists) {
            const restaurantData = doc.data();
            if (
              restaurantData.storeTiming &&
              restaurantData.storeTiming !== ""
            ) {
              allRestaurants.push({
                id: doc.id,
                ...restaurantData,
              });
            }
          }
        }
        dispatch({
          type: "ALL_RESTAURANTS",
          payload: allRestaurants,
        });
        dispatch(fetchLoader(false));
      });
  } catch (error) {
    console.error(error);
    dispatch(fetchLoader(false));
  }
};

export const getRestaurantsAction = (restaurantID) => async (dispatch) => {
  dispatch(getLoader(true));
  try {
    firebase
      .firestore()
      .collection("users")
      .where("type", "==", "restaurant")
      .where("restaurantID", "==", restaurantID)
      .onSnapshot(async (query) => {
        let temp = [];
        for (let doc of query.docs) {
          temp.push({ id: doc.id, ...doc.data() });
        }
        dispatch({ type: GET_RESTAURANT, payload: temp[0] });
        dispatch(getLoader(false));
      });
  } catch (err) {
    dispatch(getLoader(false));
    toast.error(err.message);
  }
};

export const getCatalogsAction = (id) => async (dispatch) => {
  try {
    dispatch(catalogLoader(true));
    firebase
      .firestore()
      .collection("catalogs")
      .where("restaurantID", "==", id)
      .onSnapshot(async (query) => {
        let temp = [];
        for (let doc of query.docs) {
          temp.push({ id: doc.id, ...doc.data() });
        }
        dispatch({ type: GET_CATALOGS, payload: temp });
        dispatch(catalogLoader(false));
      });
  } catch (err) {
    toast.error(err.message);
    dispatch(catalogLoader(false));
  }
};

export const getCategoriesAction = (id) => async (dispatch) => {
  try {
    firebase
      .firestore()
      .collection("categories")
      .where("restaurantID", "==", id)
      .onSnapshot(async (query) => {
        let temp = [];
        for (let doc of query.docs) {
          temp.push({ id: doc.id, ...doc.data() });
        }
        dispatch({ type: GET_CATEGORIES, payload: temp });
      });
  } catch (err) {
    toast.error(err.message);
  }
};

const getAddonImageById = async (id) => {
  try {
    const doc = await firebase.firestore().collection("addOns").doc(id).get();
    if (doc.exists) {
      const data = doc.data();
      return data?.image || null;
    }
  } catch (error) {
    console.error(`Error fetching addon image for ID ${id}:`, error);
  }
  return null;
};

export const trackOrder = (id) => async (dispatch) => {
  try {
    firebase
      .firestore()
      .collection("orders")
      .doc(id)
      .onSnapshot(async (doc) => {
        if (!doc.exists) {
          toast.warning("Order not found.");
          return;
        }
        const data = doc.data();
        const order = data?.order || [];
        const updatedOrder = await Promise.all(
          order?.map(async (item) => {
            if (!item.addons || item.addons.length === 0) return item;

            const updatedAddons = await Promise.all(
              item.addons?.map(async (addon) => {
                const image = await getAddonImageById(addon.id);
                return { ...addon, image };
              })
            );

            return { ...item, addons: updatedAddons };
          })
        );

        dispatch({
          type: "TRACK",
          payload: { id: doc.id, ...data, order: updatedOrder },
        });
      });
  } catch (e) {
    toast.error(e.message);
  }
};

export const getUserTableInfoAction = (userId) => async (dispatch) => {
  try {
    if (!userId) return;

    const db = firebase.firestore();
    const tableInfoRef = db
      .collection("users")
      .doc(userId)
      .collection("tableInfo");

    const snapshot = await tableInfoRef.limit(1).get();

    if (snapshot.empty) {
      dispatch({ type: "SET_USER_TABLE_INFO", payload: null });
      return;
    }

    const doc = snapshot.docs[0];
    const data = { id: doc.id, ...doc.data() };

    const now = Date.now();
    const expireAtMs = data?.expireAt?.seconds * 1000;
    const fiveMinutesAgo = now - 5 * 60 * 1000;

    if (!expireAtMs || expireAtMs < fiveMinutesAgo) {
      console.warn("Stale tableInfo found. Cleaning up.");
      await doc.ref.delete();
      dispatch({ type: "SET_USER_TABLE_INFO", payload: null });
      return;
    }

    dispatch({ type: "SET_USER_TABLE_INFO", payload: data });
  } catch (error) {
    console.error("Error fetching table info:", error);
    toast.error(error.message || "Failed to fetch table info.");
  }
};

export const addRestaurantFeedBack =
  (payload, onSuccess = () => {}) =>
  async (dispatch) => {
    dispatch(requestLoader(true));
    dispatch({
      type: "ADD_FEED_LOADER",
      payload: true,
    });
    try {
      firebase
        .firestore()
        .collection("restaurantFeedback")
        .add({
          ...payload,
          createdAt: firebase.firestore.Timestamp.now(),
        })
        .then(() => {
          onSuccess();
          dispatch(requestLoader(false));
          toast.success("Feedback add successfully");
          dispatch({
            type: "ADD_FEED_LOADER",
            payload: false,
          });
        })
        .catch((e) => {
          toast.error(e.message);
          dispatch(requestLoader(false));
          dispatch({
            type: "ADD_FEED_LOADER",
            payload: false,
          });
        });
    } catch (e) {
      toast.error(e.message);
      dispatch({
        type: "ADD_FEED_LOADER",
        payload: false,
      });
    }
  };

export const addPlateformFeedBack = (payload) => async (dispatch) => {
  try {
    dispatch(feedbackLoader(true));
    await firebase
      .firestore()
      .collection("platformFeedback")
      .add({
        ...payload,
        createdAt: firebase.firestore.Timestamp.now(),
      });
    toast.success("Feedback Added Successfully");
  } catch (e) {
    toast.error(e.message);
  } finally {
    dispatch(feedbackLoader(false));
  }
};

export const addRequest =
  (payload, onSuccess = () => {}) =>
  async (dispatch) => {
    dispatch(requestLoader(true));

    const { tableNumber, comments, restaurantID, customerID } = payload;

    try {
      const doc = await firebase
        .firestore()
        .collection("users")
        .doc(customerID)
        .get();

      if (!doc.exists || !doc.data()?.name) {
        toast.error("Customer name not found. Please login again.");
        dispatch(requestLoader(false));
        return;
      }

      const customerName = doc.data().name;

      await firebase.firestore().collection("requests").add({
        tableNumber,
        comments,
        restaurantID,
        customerID,
        customerName,
        status: "processing",
        createdAt: firebase.firestore.Timestamp.now(),
      });

      toast.success("Request recorded");
      onSuccess();
    } catch (error) {
      toast.error(
        "An error occurred while placing the request. Please try again."
      );
      console.error("addRequest error:", error.message);
    } finally {
      dispatch(requestLoader(false));
    }
  };

export const getMenusAction = (id, category) => async (dispatch) => {
  try {
    firebase
      .firestore()
      .collection("menus")
      .where("restaurantID", "==", id)
      .where("category", "==", category)
      .onSnapshot(async (query) => {
        let temp = [];
        if (!query.empty) {
          for (let doc of query.docs) {
            temp.push({ id: doc.id, ...doc.data() });
          }
        }

        dispatch({ type: GET_MENUS, payload: temp });
      });
  } catch (err) {
    toast.error(err.message);
  }
};

export const getLikedItems =
  (uid, menuId, categoryId) => async (dispatch) => {
    try {
      const unsubscribe = firebase
        .firestore()
        .collection("favourites")
        .where("categoryId", "==", categoryId)
        .where("userId", "==", uid)
        .where("menuId", "==", menuId)
        .onSnapshot((snapshot) => {
          const likedItems = snapshot.docs?.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          dispatch({
            type: "LIKED_ITEMS",
            payload: likedItems,
          });
        });

      return unsubscribe;
    } catch (error) {
      console.error("Error in getLikedItems:", error);
    }
  };

export const getDriverDetail = (driverId) => async (dispatch) => {
  try {
    const unsubscribe = firebase
      .firestore()
      .collection("users")
      .doc(driverId)
      .onSnapshot((doc) => {
        if (doc.exists) {
          const driverDetail = {
            id: doc.id,
            ...doc.data(),
          };
          dispatch({
            type: "DRIVER_DETAIL",
            payload: driverDetail,
          });
        }
      });

    return unsubscribe;
  } catch (error) {
    console.error("Error in getting Driver Detail:", error);
  }
};

export const getAllLikedItems = (uid) => async (dispatch) => {
  try {
    dispatch(getLikedLoading(true));

    return firebase
      .firestore()
      .collection("favourites")
      .where("userId", "==", uid)
      .onSnapshot(async (snapshot) => {
        try {
          const likedItemsRaw = snapshot.docs?.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

          const menuFetches = likedItemsRaw?.map(async (item) => {
            try {
              const menuDoc = await firebase
                .firestore()
                .collection("items")
                .doc(item?.itemId)
                .get();

              let menuData = menuDoc.exists ? menuDoc.data() : null;

              if (menuData?.labels?.length > 0) {
                const labelFetches = menuData.labels?.map(async (labelRef) => {
                  try {
                    const labelDoc = await firebase
                      .firestore()
                      .collection("labels")
                      .doc(labelRef.id)
                      .get();

                    const labelData = labelDoc.data();
                    return {
                      ...labelRef,
                      labelURL: labelData?.labelURL,
                      labelPrice: labelData?.labelPrice,
                    };
                  } catch (labelError) {
                    console.error("Error fetching label:", labelError);
                    return labelRef;
                  }
                });

                menuData.labels = await Promise.all(labelFetches);
              }

              return {
                ...item,
                menuDetail: menuData,
              };
            } catch (err) {
              console.error("Error fetching menu item:", err);
              return { ...item, menuDetail: null };
            }
          });

          const enrichedLikedItems = await Promise.all(menuFetches);

          dispatch({
            type: "ALL_LIKED_ITEMS",
            payload: enrichedLikedItems,
          });
        } catch (snapshotProcessingError) {
          console.error("Error processing snapshot:", snapshotProcessingError);
          toast.error("Failed to process liked items");
        } finally {
          dispatch(getLikedLoading(false));
        }
      });
  } catch (error) {
    console.error("Error fetching liked items:", error);
    toast.error("Failed to fetch liked items");
    dispatch(getLikedLoading(false));
  }
};

export const addLikedItem =
  (itemId, uid, menuId, categoryId) => async (dispatch) => {
    try {
      const likedItemQuery = await firebase
        .firestore()
        .collection("favourites")
        .where("userId", "==", uid)
        .where("menuId", "==", menuId)
        .where("itemId", "==", itemId)
        .get();

      if (!likedItemQuery.empty) {
        const batch = firebase.firestore().batch();
        likedItemQuery.docs.forEach((doc) => batch.delete(doc.ref));
        await batch.commit();
        toast.success("Removed from favorites");
      } else {
        await firebase.firestore().collection("favourites").add({
          userId: uid,
          menuId,
          itemId,
          categoryId,
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        });
        toast.success("Added to favorites");
      }
    } catch (error) {
      console.error("Error in addLikedItem:", error);
      toast.error("Failed to update favorite");
    }
  };

export const requestLoader = (val) => async (dispatch) => {
  dispatch({
    type: "REQUESTLOADING",
    payload: val,
  });
};

export const feedbackLoader = (val) => async (dispatch) => {
  dispatch({
    type: "FEEDBACK_LOADING",
    payload: val,
  });
};

export const getLoader = (val) => async (dispatch) => {
  dispatch({
    type: "GET_RESTAURANT_LOADER",
    payload: val,
  });
};

export const getLikedLoading = (val) => async (dispatch) => {
  dispatch({
    type: "GET_LIKED_ITEMS",
    payload: val,
  });
};

export const catalogLoader = (val) => async (dispatch) => {
  dispatch({
    type: "CATALOG_LOADER",
    payload: val,
  });
};

export const fetchLoader = (val) => async (dispatch) => {
  dispatch({
    type: "FETCH_LOADER",
    payload: val,
  });
};
